import { GAME_STAGE } from "../../utils/constant";
import { useInfoComponentStyles } from "../../styles/info-component-style";

const InfoData = () => {
  const classes = useInfoComponentStyles();
  const general = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.cardLeftSmall,
      text:
        "Hi, Welcome to MyViP@UM. Let me guide you how to help this patient!",
    },
    {
      id: 2,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "There are 5 main steps to be performed which are history taking, examination, investigation, diagnosis and management. You need to complete all these steps to complete the case.",
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardBottomRight,
      text:
        "When you click on the proceed button, you cannot go back to the previous step to perform more action.",
      independentRoot: "bottomNavDesktopRoot",
      desktopHiddenId: [
        GAME_STAGE.HISTORY_TAKING,
        GAME_STAGE.HISTORY_SUMMARY,
        GAME_STAGE.DIAGNOSIS_1,
        GAME_STAGE.EXAMINATION,
        GAME_STAGE.EXAMINATION_EVALUATION,
        GAME_STAGE.DIAGNOSIS_2,
        GAME_STAGE.INVESTIGATION,
        GAME_STAGE.INVESTIGATION_EVALUATION,
        GAME_STAGE.FINAL_DIAGNOSIS,
        GAME_STAGE.FINAL_DIAGNOSIS_EVALUATION,
        GAME_STAGE.MANAGEMENT,
        GAME_STAGE.MANAGEMENT_EVALUATION,
        GAME_STAGE.FINAL_MARKS,
        "currentStage",
        "flow",
      ],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      hideDoctorWhenSmall: true,
      card: classes.cardBottomUp,
      text:
        "After completing each step, you can see the evaluation for the step. You can also refer to evaluation for previous steps any time by clicking on the icon.",
      independentRoot: "bottomNavDesktopRoot",
      desktopHiddenId: [GAME_STAGE.FINAL_MARKS, "currentStage", "proceed"],
    },
    {
      id: 5,
      doctor: classes.doctorAtLeft,
      card: classes.cardRightDown,
      text:
        "You can click on this icon to find some resources that might help you.",
      independentRoot: "desktopHeaderRoot",
      desktopHiddenId: ["logout", "quit", "info", "casepresentation"],
    },
    {
      id: 6,
      doctor: classes.doctorAtLeft,
      hideDoctorWhenSmall: true,
      card: classes.cardRightDown2,
      text: "If you want to quit game/log out, click the exit button.",
      independentRoot: "desktopHeaderRoot",
      desktopHiddenId: ["logout", "resources", "info", "casepresentation"],
    },
    {
      id: 7,
      doctor: classes.doctorAtLeft,
      card: classes.cardRightDown,
      text:
        "If you have need help, can click on this icon and I will be there to help you.",
      independentRoot: "desktopHeaderRoot",
      desktopHiddenId: ["logout", "resources", "quit", "casepresentation"],
    },
  ];

  const historyTaking = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "In this step you should ask questions to patient to know more about his/her symptoms and background.",
    },
    {
      id: 2,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text: "Here you can ask your question to the patient.",
      hideDoctorWhenSmall: true,
      desktopHighlightId: ["historyTakingSearchbar"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "And the patient will reply you here. There might be some attachment for the reply. You can click on it to see more details.",
      desktopHighlightId: ["patient"],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text: "You can start asking patient questions now. Good luck!",
    },
  ];

  const historyTakingEvaluation = [
    {
      id: 1,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text: "Here you can review the evaluation for your history taking.",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomSmall,
      text: "First, select category to review.",
      desktopHighlightId: ["category", "categoryMobile"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomEvaluation,
      text:
        "Then, the label of the history taking type will be displayed here. Select the label you want to review.",
      desktopHighlightId: ["label", "labelMobile"],
    },
    {
      id: 4,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text: "You can see there are 3 tabs here, correct, missed, irrelevant.",
      desktopHighlightId: ["questionArea", "questionFullArea"],
    },
    {
      id: 5,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Correct tab will list all questions you asked and is relevant to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 6,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Missed tab will list all questions should be asked but you missed.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 7,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Irrelevant tab will list all questions you asked but is not related to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
  ];

  const diagnosis = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "There are 3 types of diagnosis, provisional diagnosis, differential diagnosis and final diagnosis.",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "You need to write your provisional and differential diagnosis after history taking. You may edit them again after examination.",
      desktopHighlightId: ["provisionalDiagnosis", "differentialDiagnosis"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text:
        "You need to write your final diagnosis after investigation and it is non-editable in later step.",
    },
  ];

  const examination = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "In this step you should examine patient’s body to look for possible signs.",
    },
    {
      id: 2,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text: "Click on the system or topic that you want to examine.",
      desktopHighlightId: ["examinationSystemList"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardLeft,
      text:
        "Select the body part to be examined. You can also select general appearance to check for some general sign.",
      desktopHighlightId: ["examinationBodyContainer"],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      card: classes.cardLeft,
      text: "Then, you have to key in the sign to be examined here.",
      desktopHighlightId: ["sign"],
    },
    {
      id: 5,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "And the result will be displayed here. There might be some attachment for the reply. You can click on it to see more details.",
      //desktopHighlightId: ["usedInDesktopInfo"], hide temporarily
    },
    {
      id: 6,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text: "You can start examining the patient now. All the best!",
    },
  ];

  const examinationEvaluation = [
    {
      id: 1,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text: "Here you can review the evaluation for your examination",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomSmall,
      text: "First, select system to review.",
      desktopHighlightId: ["system", "systemMobile"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomEvaluation,
      text:
        "Then, the body part of the system will be displayed here. Select the body part you want to review.",
      desktopHighlightId: ["type", "typeMobile"],
    },
    {
      id: 4,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text: "You can see there are 3 tabs here, correct, missed, irrelevant.",
      desktopHighlightId: ["questionFullArea", "questionArea"],
    },
    {
      id: 5,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Correct tab will list all signs you examined and is relevant to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 6,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text: "Missed tab will list all signs should be examined but you missed.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 7,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Irrelevant tab will list all signs you examined but is not related to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
  ];

  const investigation = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "In this step you can choose investigation to be conducted for the patient.",
    },
    {
      id: 2,
      doctor: classes.doctorAtRight,
      card: classes.cardRightDown,
      text: "Click on the investigation type.",
      desktopHighlightId: ["investigationList"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardLeftDown,
      text: "Select the category.",
      desktopHighlightId: ["investigationCategory"],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      card: classes.cardLeftDown,
      text: "Then you have to select the investigation to be conducted here.",
      desktopHighlightId: ["investigation"],
    },
    {
      id: 5,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "And the result will be displayed here. There might be some attachment for the reply. You can click on it to see more details.",
      //desktopHighlightId: ["usedInDesktopInfo"], hide temporarily
    },
    {
      id: 6,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text:
        "You can start selecting investigation for the patient now. Cheers!",
    },
  ];

  const investigationEvaluation = [
    {
      id: 1,
      doctor: classes.doctorAtLeft,
      card: classes.commonCard,
      text: "Here you can review the evaluation for your investigation.",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomSmall,
      text: "First, select investigation type to review.",
      desktopHighlightId: ["type", "typeMobile"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomEvaluation,
      text:
        "Then, the category of the investigation type will be displayed here. Select the category you want to review.",
      desktopHighlightId: ["category", "categoryMobile"],
    },
    {
      id: 4,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text: "You can see there are 3 tabs here, correct, missed, irrelevant.",
      desktopHighlightId: ["questionArea", "questionFullArea"],
    },
    {
      id: 5,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Correct tab will list all investigations you requested and is relevant to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 6,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Missed tab will list all investigations should be requested but you missed.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
    {
      id: 7,
      doctor: classes.doctorAtRight,
      card: classes.cardRightUp,
      text:
        "Irrelevant tab will list all investigations you requested but is not related to this case.",
      desktopHighlightId: ["questionFullArea", "questionArea", "resultMobile"],
    },
  ];

  const finalDiagnosis = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text: "Here you can write your final diagnosis.",
    },
  ];

  const diagnosisEvaluation = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text: "Here you can review the evaluation for your final diagnosis.",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "Your answer will be displayed on the left and the sample answer will be displayed on the right.",
      desktopHighlightId: ["yourAnswer", "sampleAnswer"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text: "The correct keywords in your answer will be highlighted green.",
      desktopHighlightId: ["yourAnswer"],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text:
        "The keywords that you missed will be highlighted red in the sample answer.",
      desktopHighlightId: ["sampleAnswer"],
    },
  ];

  const management = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text:
        "There are 2 types of management, short term management and long term management. You need to write your management after final diagnosis.",
    },
  ];

  const managementEvaluation = [
    {
      id: 1,
      doctor: classes.doctorAtRight,
      card: classes.commonCard,
      text: "Here you can review the evaluation for your management.",
    },
    {
      id: 2,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottom,
      text: "First, select management type to review.",
      desktopHighlightId: ["listview", "listviewMobile"],
    },
    {
      id: 3,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomTop,
      text:
        "Your answer will be displayed on the left and the sample answer will be displayed on the right.",
      desktopHighlightId: ["yourManagement", "sampleManagement"],
    },
    {
      id: 4,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomTop,
      text: "The correct keywords in your answer will be highlighted green.",
      desktopHighlightId: ["yourManagement"],
    },
    {
      id: 5,
      doctor: classes.doctorAtLeft,
      card: classes.cardAtBottomTop,
      text:
        "The keywords that you missed will be highlighted in the sample answer.",
      desktopHighlightId: ["sampleManagement"],
    },
  ];

  return [
    general,
    historyTaking,
    historyTakingEvaluation,
    diagnosis,
    examination,
    examinationEvaluation,
    diagnosis,
    investigation,
    investigationEvaluation,
    finalDiagnosis,
    diagnosisEvaluation,
    management,
    managementEvaluation,
  ];
};

export default InfoData;
